/**
 * @file Builds `ChargeTemplate` entities from backend charge-template payloads,
 * mapping every field explicitly (no spread), `paymentRouteId` included as a
 * plain copy — charge-template responses always carry it.
 *
 * Flow: `GET/POST/PUT charge-templates` payload item → `create(data)` field map
 * → `ChargeTemplate` entity; `reinitialize` re-wraps an already-mapped `.data`.
 * Exceptions: none.
 */
import Factory from "../Factory";
import { FactoryInterface } from "../FactoryInterface";

import { ChargeTemplate } from "../Entities/Charge/ChargeTemplate";
import { ChargeTemplateInterface } from "../Entities/Charge/ChargeTemplateInterface";

import CurrencyContainer from "../../Currency/CurrencyContainer";

import PaymentOffsetContainer from "../Entities/Charge/PaymentOffset/PaymentOffsetContainer";
import Store from "../../Store/Store";

class ChargeTemplateFactory extends Factory implements FactoryInterface {
  public create(data: any): ChargeTemplateInterface {
    return new ChargeTemplate({
      id: data.id,
      contractId: data.contractId,
      unitId: data.unitId,
      propertyId: data.propertyId,
      amount: data.amount,
      currency: CurrencyContainer.pickFromId(data.currencyId),
      repeatPeriod: Store.getConfigurator().getState().globalTypes?.RepeatPeriod?.[data.repeatPeriodId],
      chargeClass: Store.getConfigurator().getState().globalTypes?.ChargeClass?.[data.chargeClassId],
      paymentOffset: PaymentOffsetContainer.pickFromId(data.paymentOffset),
      type: Store.getConfigurator().getState().globalTypes?.ChargeType?.[data.type],
      description: data.description,
      isDefault: data.isDefault,
      dueDateFirstPayment: data.dueDateFirstPayment === null ? null : new Date(data.dueDateFirstPayment),
      firstDate: data.firstDate === null ? null : new Date(data.firstDate),
      endDate: data.endDate === null ? null : new Date(data.endDate),
      removed: data.removed,
      creationDate: new Date(data.createdAt),
      paymentRouteId: data.paymentRouteId,
      // TODO change type in DB to number and remove these checkings
      companyId: data.companyId ? Number(data.companyId) : null,
      contactId: data.contactId ? Number(data.contactId) : null,
      isCollective: data.isCollective
    });
  }

  public reinitialize(data: any): ChargeTemplateInterface {
    return new ChargeTemplate({
      ...data
    });
  }
}

export default new ChargeTemplateFactory();
